import { render, staticRenderFns } from "./tabBookingFCLUICustom.vue?vue&type=template&id=3638d47a&scoped=true&"
import script from "./tabBookingFCLUICustom.vue?vue&type=script&lang=js&"
export * from "./tabBookingFCLUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingFCLUICustom.vue?vue&type=style&index=0&id=3638d47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638d47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3638d47a')) {
      api.createRecord('3638d47a', component.options)
    } else {
      api.reload('3638d47a', component.options)
    }
    module.hot.accept("./tabBookingFCLUICustom.vue?vue&type=template&id=3638d47a&scoped=true&", function () {
      api.rerender('3638d47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLUICustom.vue"
export default component.exports